import { PosPlugin } from 'plugins/plugin';
import { ComponentHeader } from 'plugins/cayanCustomerDisplay/ComponentHeader';

const pluginID = 'cayanCustomerDisplay';

const cayanCustomerDisplayPlugin: PosPlugin = {
  id: pluginID,
  name: 'TSYS/Genius terminal customer display',
  ComponentHeader,
};

export default cayanCustomerDisplayPlugin;
